<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'50%'">
    <v-card v-if="itemDetail">
      <v-card-title>{{title}}</v-card-title>
      <v-card-text>
        <v-layout>
          <v-text-field v-model="itemDetail.title"
                        :label="`主分類`"
                        :color="Theme.GREEN"></v-text-field>
        </v-layout>
        <v-layout>
          <v-text-field v-model="itemDetail.sort"
                        :label="`主分類排序`"
                        :color="Theme.GREEN"></v-text-field>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-btn dark :color="Theme.GREEN" @click="addSubType">新增子類別</v-btn>
          </v-flex>
        </v-layout>
        <br/>
        <v-layout>
          <span>子分類</span>
        </v-layout>
        <v-layout>
          <v-flex xs12 md3 span="2" v-for="(subtype, i) of itemDetail.subTypeList" :key="`key_${i}`">
            <v-text-field v-model="subtype.name"
                          :label="`#${i}`"
                          :color="Theme.GREEN"></v-text-field>
            <v-text-field v-model="subtype.sort"
                          :label="`排序`"
                          :color="Theme.GREEN"></v-text-field>
            <v-btn dark :color="Theme.ORANGE" @click="removeSubType(i)">刪除</v-btn>
          </v-flex>
        </v-layout>

      </v-card-text>
      <v-card-actions>
        <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import {mapActions} from "vuex";

export default {
  name: "productTypeDetail",
  mixins: [common],
  props: {
    title:String,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data(){
    return {
      saveLoading: false,
    };
  },
  methods:{
    ...mapActions(['saveTypeList','removeSubTypeInfo','removeTypeInfo']),
    addSubType(){
      this.itemDetail.subTypeList.push({
        typeId: this.itemDetail.typeId,
        name: '',
        sort: 0,
      });
    },
    async removeSubType(i){
      const subType = this.itemDetail.subTypeList[i];
      if (subType.subId && subType.subId !==''){
        const res = await this.removeSubTypeInfo({ subId: subType.subId });
        const result = res.data;
        console.log(`removeSubTypeInfo == ${JSON.stringify(result)}`);
      }
      this.itemDetail.subTypeList.splice(i, 1);
    },
    cancelEvent() {
      this.$emit('cancelEvent');
    },
    async confirmEvent() {
      try {
        this.saveLoading = true;
        console.log(`save ${JSON.stringify(this.itemDetail)}`);
        const res = await this.saveTypeList({ info: this.itemDetail});
        const result = res.data;
        this.saveLoading = false;
        if (result.statusCode === 0) {
          this.$emit('confirmEvent', this.itemDetail);
        } else {
          this.showMessageDialog('錯誤', result.message ? result.result : '儲存失敗');
        }
      } catch (e) {
        this.saveLoading = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
